export const TREATMENT_REPORT_HEADERS = [
  { label: "Category", key: "category" },
  { label: "Product Family", key: "productFamily" },
  { label: "Material #", key: "material" },
  { label: "Material Description", key: "materialDescription" },
  { label: "# Applied", key: "noOfApplied" },
  { label: "% Utilization", key: "utilization" },
  { label: "Avg. Change Frequency", key: "avgChangeFrequency" },
  { label: "Avg. Rate of Healing", key: "avgRateOfHealing" },
];

export const OVERVIEW_COUNT_CONFIG = [
  {
    key: "Wound Cleansers",
    crdClass: "crd_opt_1",
    dataPath: "woundCleansers",
  },
  {
    key: "Skin Protectants",
    crdClass: "crd_opt_2",
    dataPath: "skinProtectants",
  },
  {
    key: "Primary Dressings",
    crdClass: "crd_opt_3",
    dataPath: "primaryDressings",
  },
  {
    key: "Secondary Dressings",
    crdClass: "crd_opt_4",
    dataPath: "secondaryDressings",
  },
  {
    key: "Compression",
    crdClass: "crd_opt_5",
    dataPath: "compression",
  },
];

export const TREATMENT_REPORT_COLUMNS = [
  {
    Header: "Product photo",
    accessor: "productFamilyImage",
    imageData: "picture",
    restWidth: "150px",
    disableSortBy: true,
  },
  { Header: "Category", accessor: "category", restWidth: "150px" },
  { Header: "Product family", accessor: "productFamily", restWidth: "320px" },
  { Header: "Material #", accessor: "material" },
  { Header: "Material description", accessor: "materialDescription", restWidth: "350px" },
  { Header: "# Applied", accessor: "noOfApplied", restWidth: "120px" },
  { Header: "% Utilization", accessor: "utilization" },
];

export const AVG_RATE_OF_HEALING_COL = {
  Header: "Avg. Rate of Healing",
  accessor: "avgRateOfHealing",
  restWidth: "165px",
};

export const AVG_CHANGE_FREQUENCY_COL = {
  Header: "Avg. Change Frequency",
  accessor: "avgChangeFrequency",
  restWidth: "200px",
};
